
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const AnimalGroupsTable = () => {
  const animals = [
    { id: 1, name: "Avestruz", group: "01", numbers: "01 02 03 04" },
    { id: 2, name: "Águia", group: "02", numbers: "05 06 07 08" },
    { id: 3, name: "Burro", group: "03", numbers: "09 10 11 12" },
    { id: 4, name: "Borboleta", group: "04", numbers: "13 14 15 16" },
    { id: 5, name: "Cachorro", group: "05", numbers: "17 18 19 20" },
    { id: 6, name: "Cabra", group: "06", numbers: "21 22 23 24" },
    { id: 7, name: "Carneiro", group: "07", numbers: "25 26 27 28" },
    { id: 8, name: "Camelo", group: "08", numbers: "29 30 31 32" },
    { id: 9, name: "Cobra", group: "09", numbers: "33 34 35 36" },
    { id: 10, name: "Coelho", group: "10", numbers: "37 38 39 40" },
    { id: 11, name: "Cavalo", group: "11", numbers: "41 42 43 44" },
    { id: 12, name: "Elefante", group: "12", numbers: "45 46 47 48" },
    { id: 13, name: "Galo", group: "13", numbers: "49 50 51 52" },
    { id: 14, name: "Gato", group: "14", numbers: "53 54 55 56" },
    { id: 15, name: "Jacaré", group: "15", numbers: "57 58 59 60" },
    { id: 16, name: "Leão", group: "16", numbers: "61 62 63 64" },
    { id: 17, name: "Macaco", group: "17", numbers: "65 66 67 68" },
    { id: 18, name: "Porco", group: "18", numbers: "69 70 71 72" },
    { id: 19, name: "Pavão", group: "19", numbers: "73 74 75 76" },
    { id: 20, name: "Peru", group: "20", numbers: "77 78 79 80" },
    { id: 21, name: "Touro", group: "21", numbers: "81 82 83 84" },
    { id: 22, name: "Tigre", group: "22", numbers: "85 86 87 88" },
    { id: 23, name: "Urso", group: "23", numbers: "89 90 91 92" },
    { id: 24, name: "Veado", group: "24", numbers: "93 94 95 96" },
    { id: 25, name: "Vaca", group: "25", numbers: "97 98 99 00" }
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Os grupos e números do Jogo do Bicho</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className="border border-gray-300 p-2 bg-green-50 font-bold text-sm">GRUPO</th>
                <th className="border border-gray-300 p-2 bg-green-50 font-bold text-sm">BICHO</th>
                <th className="border border-gray-300 p-2 bg-green-50 font-bold text-sm">DEZENAS</th>
              </tr>
            </thead>
            <tbody>
              {animals.map((animal, index) => (
                <tr key={animal.id} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                  <td className="border border-gray-300 p-1 text-center text-sm font-bold">
                    {animal.group}
                  </td>
                  <td className="border border-gray-300 p-1 text-center text-sm">
                    {animal.name}
                  </td>
                  <td className="border border-gray-300 p-1 text-center text-sm font-mono">
                    {animal.numbers}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-xs text-center text-muted-foreground mt-4">
          Cada grupo do bicho é composto por 4 dezenas
        </p>
      </CardContent>
    </Card>
  );
};

export default AnimalGroupsTable;
